<template>
  <div class="campaign-container">
    <div ref="conteudo_campanha"></div>
  </div>
</template>

<script>
import api from '@/services/api';
import config from '@/config';

export default {
  name: 'Campanha',
  components: {
  },
  data() {
    return {
      recnum: null,
      templateElements: null,
      resizeObserver: null,
    };
  },
  async beforeRouteEnter(to, from, next) {
    const { recnum } = to.params;
    next(vm => {
      vm.recnum = recnum;
      vm.conteudo(recnum);
    });
  },
  mounted() {
    window.responderCampanha = this.responderCampanha;
    window.campanhaVueInstance = this;
    this.setupResizeObserver();
  },
  beforeDestroy() {
    delete window.responderCampanha;
    delete window.campanhaVueInstance;
    this.destroyResizeObserver();
  },
  methods: {
    responderCampanha(resposta) {
      this.enviarResposta(resposta);
    },
    async enviarResposta(resposta) {
      try {
        if (this.isLinkInterno(resposta)) {
          // Link interno - fazer POST na API
          await api.post(resposta, {
            usuario: this.$store.state.user?.id || null,
            campanha: this.recnum,
          });

          // Fechar modal com id "campanha" após envio bem-sucedido
          this.fecharModalCampanha();
        } else {
          // Link externo - abrir em nova aba
          window.open(resposta, '_blank');

          // Fechar modal também para links externos
          this.fecharModalCampanha();
        }
      } catch (error) {
        console.error('Erro ao processar resposta:', error);
      }
    },
    fecharModalCampanha() {
      window.parent.postMessage('FecharModalCampanha', '*');
    },
    async enviarAltura() {
      setTimeout(() => {
        const container = document.querySelector('.campaign-container');
        if (container) {
          const altura = container.offsetHeight;
          window.parent.postMessage({
            type: 'campaign-height',
            height: altura,
          }, '*');
        }
      }, 100);
    },
    isLinkInterno(link) {
      if (!link || typeof link !== 'string') return false;

      return link.startsWith(config.apiUrl);
    },
    async conteudo(recnum) {
      await api.get(`/api/campanhas/conteudo/${recnum}`).then(result => {
        const { conteudo } = result.data.data;

        if (typeof conteudo === 'string') {
          try {
            this.templateElements = JSON.parse(conteudo);
          } catch (e) {
            console.error('Erro ao fazer parse do conteúdo:', e);
            this.templateElements = [];
          }
        } else if (Array.isArray(conteudo)) {
          this.templateElements = conteudo;
        } else {
          this.templateElements = [];
        }
      });
      await this.exportHtml();
    },
    async exportHtml() {
      let html = '<div class="campaign-template">';

      // Usar a ordem do array em vez de ordenar por posição Y
      // para manter a estrutura sequencial dos elementos
      this.templateElements.forEach(element => {
        switch (element.type) {
          case 'text': {
            const textStyles = `
              font-size: ${element.fontSize || '16px'};
              color: ${element.color || 'inherit'};
              text-align: ${element.textAlign || 'left'};
              font-weight: ${element.bold ? 'bold' : 'normal'};
              font-style: ${element.italic ? 'italic' : 'normal'};
              text-decoration: ${element.underline ? 'underline' : 'none'};
            `;
            html += `<div style="${textStyles}">${element.content}</div>`;
            break;
          }
          case 'image':
            html += `<div style="text-align: ${element.align || 'left'};">
              <img src="${element.src}" alt="${element.alt}" style="width: ${element.width}px; max-width: 100%;">
            </div>`;
            break;
          case 'button': {
            html += `<div class="buttons-inline-group" style="text-align: ${element.align || 'left'};">`;
            element.buttons.forEach(btn => {
              const iconHtml = btn.icon ? `<i class="${btn.icon} icon"></i> ` : '';
              html += `<button 
                type="button" 
                class="ui button ${btn.color}" 
                data-resposta="${btn.link}"
                data-campanha-btn="true"
              >
                ${iconHtml}${btn.label}
              </button>`;
            });
            html += '</div>';
            break;
          }
          case 'divider':
            html += '<div class="ui divider"></div>';
            break;
          case 'spacer':
            html += `<div style="height: ${element.height}px;"></div>`;
            break;
          case 'iframe':
            if (element.src) {
              html += `<div class="iframe-wrapper">
                <iframe 
                  src="${element.src}" 
                  width="${element.width}" 
                  height="${element.height}"
                  frameborder="${element.frameborder || '0'}"
                  ${element.allowfullscreen ? 'allowfullscreen' : ''}
                  title="${element.title || 'Iframe'}"
                  style="border: 1px solid #ddd; border-radius: 4px; max-width: 100%;">
                </iframe>
              </div>`;
            }
            break;
          default:
            html += '<div>Elemento desconhecido</div>';
            break;
        }
      });
      html += '</div>';

      this.$refs.conteudo_campanha.innerHTML = html;

      this.adicionarEventListeners();
    },
    adicionarEventListeners() {
      const botoesCampanha = this.$refs.conteudo_campanha.querySelectorAll('[data-campanha-btn="true"]');

      botoesCampanha.forEach(botao => {
        botao.addEventListener('click', (event) => {
          const resposta = event.target.getAttribute('data-resposta');
          if (resposta) {
            this.responderCampanha(resposta);
          }
        });
      });
    },
    setupResizeObserver() {
      if (!this.$refs.conteudo_campanha) return;

      this.resizeObserver = new ResizeObserver((entries) => {
        entries.forEach(entry => {
          const altura = document.querySelector('.campaign-container').offsetHeight;
          window.parent.postMessage({
            type: 'campaign-height',
            height: altura,
          }, '*');
        });
      });

      this.resizeObserver.observe(this.$refs.conteudo_campanha);
    },
    destroyResizeObserver() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }
    },
  },
};
</script>

<style scoped>
/* Container principal da campanha */
.campaign-container {
  max-width: 700px;
  padding: 20px;
  box-sizing: border-box;
  margin: 0 auto;
}

/* Estilos para o conteúdo da campanha */
.campaign-template {
  line-height: 1.6;
}

/* Espaçamento entre elementos */
.campaign-template > * {
  margin-bottom: 15px;
}

.campaign-template > *:last-child {
  margin-bottom: 0;
}

/* Melhorias para botões */
.buttons-inline-group {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 15px;
}

.buttons-inline-group .ui.button {
  margin: 0;
}

/* Responsividade */
@media (max-width: 768px) {
  .campaign-container {
    padding: 15px;
  }

  .buttons-inline-group {
    flex-direction: column;
  }

  .buttons-inline-group .ui.button {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .campaign-container {
    padding: 10px;
  }
}
</style>
